module.exports = __webpack_public_path__ + "static/media/reddy-architecture-urbanism.55fe7c1c.png";